$.fn.conditionalCheckbox = function () {
  return this.each(function () {
    var $control = $(this);
    var $target = $($control.data("target")).closest(".form-group");

    function _toggleTarget() {
      if ($control.is(":checked")) {
        $target.show();
      } else {
        $target.hide();
      }
    }

    $control.change(_toggleTarget);

    _toggleTarget();
  });
};

$.fn.fileUploadCheckBox = function () {
  var $control = $(this);
  var $fileUploadContainer = $(".file-upload-container");
  var $target = $fileUploadContainer.find("#fileUpload");
  var $targetLabel = $fileUploadContainer
    .find('label[for="fileUpload"]')
    .first();

  // Array of jQuery objects to have their 'disabled' state toggled
  var targets = [$target, $targetLabel];

  // if there is a checkbox configured to use this plugin...
  // toggle the targets passed in to the _toggleTarget method
  if ($control.length) _toggleTarget(targets);

  // Function, for enabling or disabling elements which the checkbox
  // is meant to have influence over...
  function _toggleTarget(_targets) {
    $.each(_targets, function (index, elem) {
      if ($control.is(":checked")) {
        // elem.prop('disabled', null);
        elem.removeAttr("disabled");
      } else {
        // elem.prop('disabled',  'disabled');
        elem.attr("disabled", "disabled");
      }
    });
  }

  // Event Handling for when the checkbox state changes
  $control.on("change", function () {
    _toggleTarget(targets);
  });
};
